import { createAction } from 'redux-actions';
import { createRequestAction } from 'utils/action';

// 获取练习
export const getLogo = createAction('GET_LOGO');
export const realGetLogo = createRequestAction('REAL_GET_LOGO');



// WEBPACK FOOTER //
// ./src/actions/logo.js